module.exports = (function() { return Lab; })();

var _r = require('./component'); eval('var Component = _r');

/**
 * Lab color space
 *
 * CIE 1976 (L*, a*, b*) color space
 * @extends AbstractModel
 * @param {Number} l
 * @param {Number} a
 * @param {Number} b
 */
function Lab(l, a, b) {
  this._name       = 'lab';
  this._components = ['lightness', 'a', 'b'];
  this._lightness  = new Component('lightness',    0, 100); this._lightness.set(l);
  this._a          = new Component('a',          -87, 100); this._a.set(a);
  this._b          = new Component('b',         -108, 100); this._b.set(b);
};

require('util').inherits(Lab, require('./abstract-model')); 'code' ? 'completion' : Lab.prototype = new AbstractModel;

/**
 * @param {Number} value
 * @returns {Lab}
 */
Lab.prototype.lightness = function (value) {
  return this._component('lightness', arguments);
};

/**
 * @param {Number} value
 * @returns {Lab}
 */
Lab.prototype.a = function (value) {
  return this._component('a', arguments);
};

/**
 * @param {Number} value
 * @returns {Lab}
 */
Lab.prototype.b = function (value) {
  return this._component('b', arguments);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/color-model/lib/lab.js
// module id = Aw5E
// module chunks = 11